import { Box, Dialog, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useState } from "react";

type MediaImageProps = {
  src: string;
  alt?: string;
  className?: string;
  thumbClassName?: string;
};

/** Thumbnail that opens a full preview dialog (close via X, backdrop, or Escape). */
export default function MediaImage({
  src,
  alt = "",
  className,
  thumbClassName = "w-[70px] mt-2",
}: MediaImageProps) {
  const [open, setOpen] = useState(false);

  if (!src) return null;

  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`${thumbClassName} cursor-pointer object-contain ${className || ""}`}
        onClick={() => setOpen(true)}
      />
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="md"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "transparent",
            boxShadow: "none",
            overflow: "visible",
            m: 2,
          },
        }}
        BackdropProps={{
          sx: { backgroundColor: "rgba(0, 0, 0, 0.75)" },
        }}
      >
        <Box className="relative flex items-center justify-center">
          <IconButton
            aria-label="close"
            onClick={() => setOpen(false)}
            sx={{
              position: "absolute",
              top: -40,
              right: 0,
              color: "#fff",
              backgroundColor: "rgba(0,0,0,0.35)",
              "&:hover": { backgroundColor: "rgba(0,0,0,0.55)" },
              zIndex: 1,
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            component="img"
            src={src}
            alt={alt}
            sx={{
              maxWidth: "100%",
              maxHeight: "85vh",
              objectFit: "contain",
              borderRadius: 1,
              display: "block",
              backgroundColor: "#fff",
            }}
          />
        </Box>
      </Dialog>
    </>
  );
}
